import { render, staticRenderFns } from "./OrderGoodsManagement.vue?vue&type=template&id=27f4147e&scoped=true"
import script from "./OrderGoodsManagement.vue?vue&type=script&lang=js"
export * from "./OrderGoodsManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderGoodsManagement.vue?vue&type=style&index=0&id=27f4147e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4147e",
  null
  
)

export default component.exports